import * as React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '../../interfaces/IIcon';

export function EmailCheckMark(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g fill="#006295">
                <path d="M33.778 12.49V3.556C33.778 1.595 32.183 0 30.222 0H3.555C1.595 0 0 1.595 0 3.556v17.777c0 1.961 1.595 3.556 3.556 3.556H23.49C24.655 28.987 28.423 32 32.89 32c5.391 0 9.778-4.386 9.778-9.778 0-5.091-3.913-9.281-8.89-9.733zM3.556 1.777h26.666c.037 0 .068.019.105.02L17.62 12.23c-.452.286-1.107.225-1.402.045L3.452 1.8c.036-.002.067-.021.104-.021zm19.6 21.333h-19.6c-.98 0-1.778-.798-1.778-1.778V3.556c0-.252.055-.49.15-.707l13.24 10.858c.518.337 1.113.515 1.721.515.585 0 1.157-.165 1.66-.477.05-.027.099-.06.144-.096l13.156-10.8c.095.217.151.455.151.707v8.934c-4.976.45-8.889 4.64-8.889 9.732 0 .3.019.596.045.89zm9.733 7.111c-4.412 0-8-3.588-8-8 0-4.411 3.588-8 8-8 4.411 0 8 3.589 8 8 0 4.412-3.589 8-8 8z" />
                <path d="M36.705 18.927l-5.594 5.594-2.038-2.038c-.347-.348-.91-.348-1.257 0-.347.347-.347.91 0 1.257l2.667 2.666c.173.174.4.26.628.26.228 0 .455-.086.629-.26l6.222-6.222c.347-.347.347-.91 0-1.257-.347-.347-.91-.347-1.257 0z" />
            </g>
        </Icon>
    );
}
